import {
  IconWrap,
  AccountingBillIcon,
  MealBenefitIcon,
  MealVoucherIcon,
  BasketBonusIcon,
  MealIcon,
  Tooltip,
  Flex
} from '@libs/ui/ds'
import { usePlanningTranslation } from '@libs/utils/translations'
import { CardFooter } from '@spa/scenes/Plannings/components'
import type { ShiftModel } from '@spa/scenes/Plannings/redux/models/Shift'
import type { FC } from 'react'
import React from 'react'
import getPlannedMeals from 'snap-redux/modules/shifts/utils/meals/getPlannedMeals'
import getRealMeals from 'snap-redux/modules/shifts/utils/meals/getRealMeals'

import isPast from '../../utils/isPast'

type Props = {
  shift: ShiftModel
}

const getIconName = (value: string) => {
  switch (value) {
    case 'TR':
      return <MealVoucherIcon />
    case 'IR':
      return <AccountingBillIcon />
    case 'AN':
      return <MealBenefitIcon />
    case 'PP':
      return <BasketBonusIcon />
    default:
      return null
  }
}

const ShiftMeals: FC<Props> = ({ shift }) => {
  const { t } = usePlanningTranslation()

  const past = isPast(shift.starts_at)
  const meals = {
    real: getRealMeals(shift.shift_meals),
    planned: getPlannedMeals(shift.shift_meals)
  }

  const total = past ? meals.real.length : meals.planned.length

  if (total === 0 || shift.did_not_show) {
    return null
  }

  return (
    <CardFooter.ActionItem>
      <Tooltip
        label={t('weekly.card.shiftMeals', { count: total })}
        data-testid='shift-meal'
      >
        <div className='flex'>
          {total > 1 && (
            <Flex row className='items-center'>
              <div>{total}</div>
              <IconWrap icon={<MealIcon />} size='s' />
            </Flex>
          )}
          {total === 1 && (
            <IconWrap
              icon={getIconName(
                past
                  ? meals.real[0].real_meal_type
                  : meals.planned[0].planned_meal_type
              )}
              size='s'
            />
          )}
        </div>
      </Tooltip>
    </CardFooter.ActionItem>
  )
}

export default ShiftMeals
